import * as React from 'react'
import * as _ from 'lodash'

export const uniqueId = () => _.uniqueId()



// WEBPACK FOOTER //
// ./src/lib/sbhtml/sbhtml.ts